module.exports = __webpack_public_path__ + "img/guideBtn1.51534ea1.png";